import { FaLinkedinIn, FaTelegramPlane } from "react-icons/fa";
import { BsInstagram } from "react-icons/bs";
import { FiGithub } from "react-icons/fi";

const Footer = () => {
  return (
    <footer id="footer">
      <a href="#" className="footer_logo">
        Amir Ebrahimi
      </a>
      <ul className="permalinks">
        <li>
          <a href="#">Home</a>
        </li>
        <li>
          <a href="#about">About</a>
        </li>
        <li>
          <a href="#experience">Experience</a>
        </li>
        <li>
          <a href="#services">Services</a>
        </li>
        <li>
          <a href="#portfolio">Portfolio</a>
        </li>
        <li>
          <a href="#testimonial">Testimonial</a>
        </li>
        <li>
          <a href="#contact">Contact</a>
        </li>
      </ul>

      <div className="footer_socials">
        <a href="https://www.linkedin.com/in/amir-ebrahimi1-/">
          <FaLinkedinIn />
        </a>
        <a href="https://t.me/amirjzp">
          <FaTelegramPlane />
        </a>
        <a href="https://github.com/amir-h-e">
          <FiGithub />
        </a>
      </div>

      <div className="footer_copyright">
        <small>&copy; AMIR.H EBRAHIMI</small>
      </div>
    </footer>
  );
};

export default Footer;
